import { connect } from 'react-redux';

import ShipmentComponent from './shipment.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentComponent);



// WEBPACK FOOTER //
// ./src/components/shipment/shipment/shipment.ts